import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import {
  LimitPlanDialogData,
  RestrictionType,
} from "./limit-plan-dialog.interface";

@Component({
  selector: "app-limit-plan-dialog",
  templateUrl: "./limit-plan-dialog.component.html",
  styleUrls: ["./limit-plan-dialog.component.scss"],
  standalone: false,
})
export class LimitPlanDialogComponent {
  plan: "free" | "freemium" | "basic";
  planName: string;
  restrictionType: RestrictionType;

  constructor(
    private dialogRef: MatDialogRef<LimitPlanDialogComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: LimitPlanDialogData,
  ) {
    this.plan = data.plan;
    this.planName = this.plan.charAt(0).toUpperCase() + this.plan.slice(1);
    this.restrictionType = data.type || "general";
  }

  goToSubscription(): void {
    this.dialogRef.close();
    void this.router.navigate(["/subscription"]);
  }

  close(): void {
    this.dialogRef.close();
  }
}
